function imageDimensions(src, callback) {
    let img = new Image();
    let boundAfter = callback.bind(this);
    img.onload = function () {
        boundAfter(img.width, img.height);
    };
    img.src = src;
};

module.exports = imageDimensions;


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/utils/image-size.js